// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.style_label__yTnLp {
  color: var(--colorTextTertiary);
  font-size: 0.8125rem;
  font-weight: 400;
  margin-bottom: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./app/components/form/InputLabel/style.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;AATF;EACI,+BAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AAWJ","sourcesContent":["@import \"../../../resources/styles/colors\";\n@import \"../../../resources/styles/variables\";\n\n.label {\n    color: @secondaryText;\n    font-size: 0.8125rem;\n    font-weight: @normal;\n    margin-bottom: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `style_label__yTnLp`
};
module.exports = ___CSS_LOADER_EXPORT___;
